<template>
  <b-modal
    ref="exportModal"
    :title="modalTitle"
    size="md"
    hide-footer
    centered
  >
    <div class="p-0">
      <b-form @submit.prevent="handleExport">
        <b-form-group label="Phạm vi xuất">
          <b-form-radio-group
            v-model="options.exportScope"
            :options="exportScopeOptions"
            stacked
          />
        </b-form-group>

        <b-form-group label="Cột cần xuất">
          <b-form-checkbox-group
            v-model="options.selectedFields"
            :options="fieldOptions"
            stacked
          />
        </b-form-group>

        <div class="d-flex justify-content-end mt-4">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="hideModal"
            :disabled="isExporting"
          >
            Hủy
          </b-button>
          <b-button
            type="submit"
            variant="primary"
            :disabled="isExporting || options.selectedFields.length === 0"
          >
            <b-spinner
              small
              v-if="isExporting"
              class="mr-1"
            ></b-spinner>
            {{ isExporting ? 'Đang xuất...' : 'Xuất Excel' }}
          </b-button>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import { makeToastFaile, makeToastSuccess } from '@/utils/common';

export default {
  name: 'BaseExportModal',
  props: {
    moduleName: {
      type: String,
      required: true,
    },
    exportService: {
      type: Object,
      required: true,
    },
    searchParams: {
      type: Object,
      default: () => ({}),
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    fieldOptions: {
      type: Array,
      required: true,
    },
    defaultSelectedFields: {
      type: Array,
      default: () => [],
    },
    defaultFileName: {
      type: String,
      default: 'export-data',
    },
    filterMapping: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isExporting: false,
      options: {
        fileName: this.defaultFileName,
        exportScope: 'all',
        selectedFields: [...this.defaultSelectedFields],
      },
      exportScopeOptions: [
        { text: 'Tất cả dữ liệu', value: 'all' },
        { text: 'Dữ liệu hiện tại (theo bộ lọc)', value: 'filtered' },
      ],
    };
  },
  computed: {
    modalTitle() {
      return `Xuất Excel ${this.moduleName}`;
    },
  },
  methods: {
    showModal() {
      this.$refs.exportModal.show();
    },

    hideModal() {
      this.$refs.exportModal.hide();
    },

    async handleExport() {
      if (this.options.selectedFields.length === 0) {
        makeToastFaile('Vui lòng chọn ít nhất một cột để xuất');
        return;
      }

      this.isExporting = true;

      try {
        const params = {
          fields: this.options.selectedFields.join(','),
          fileName: this.options.fileName,
        };

        // Add search filters if exporting filtered data
        if (this.options.exportScope === 'filtered') {
          this.applyFilters(params);
        }

        await this.exportService.exportToExcel(params);

        makeToastSuccess('Xuất Excel thành công');
        this.hideModal();
        this.$emit('export-success');
      } catch (error) {
        console.error('Export error:', error);
        const errorMessage =
          error.response?.data?.message || 'Có lỗi xảy ra khi xuất Excel';
        makeToastFaile(errorMessage);
      } finally {
        this.isExporting = false;
      }
    },

    applyFilters(params) {
      // Apply filters based on filterMapping or use searchParams directly
      if (Object.keys(this.filterMapping).length > 0) {
        // Use custom filter mapping
        Object.keys(this.filterMapping).forEach(key => {
          const searchKey = this.filterMapping[key];
          if (this.searchParams[searchKey] !== null && 
              this.searchParams[searchKey] !== '' && 
              this.searchParams[searchKey] !== undefined) {
            params[key] = this.searchParams[searchKey];
          }
        });
      } else {
        // Use searchParams directly (backward compatibility)
        Object.keys(this.searchParams).forEach(key => {
          if (this.searchParams[key] !== null && 
              this.searchParams[key] !== '' && 
              this.searchParams[key] !== undefined) {
            params[key] = this.searchParams[key];
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.form-group label {
  font-weight: 600;
  color: #6c757d;
}
</style>
